export default __webpack_public_path__ + "locales/uk-UA/Common.json?hash=34952d01991b6216e7807a721dc2b56b";